// Curated Etsy reviews shown on the homepage (carousel).
// RULES: copy reviews VERBATIM from https://www.etsy.com/shop/MyGuardPod/reviews — never edit the original
// text. `text.fr` is a courtesy translation shown on the FR site only. Optional: country, date ('YYYY-MM').
// When the Etsy API key arrives, this file becomes the fallback for the live feed.

export const ETSY_REVIEWS_URL = 'https://www.etsy.com/shop/MyGuardPod/reviews';

export const REVIEWS = [
  {
    id: 'baggies',
    rating: 5,
    text: {
      en: 'We had been carrying our kids\u2019 medications around in plastic baggies before. This is a huge improvement.',
      fr: 'Nous transportions les m\u00e9dicaments de nos enfants dans des sacs en plastique avant. C\u2019est une \u00e9norme am\u00e9lioration.',
    },
    author: { en: 'Verified Customer', fr: 'Client v\u00e9rifi\u00e9' },
  },
  {
    id: 'daughter-rescue-med',
    rating: 5,
    text: {
      en: 'Perfect way to carry my daughter\u2019s rescue med.',
      fr: 'La fa\u00e7on parfaite de transporter le m\u00e9dicament de secours de ma fille.',
    },
    author: { en: 'Verified Customer', fr: 'Client v\u00e9rifi\u00e9' },
  },
  {
    id: 'real-patients',
    rating: 5,
    text: {
      en: 'Fantastic product made for the needs of real patients.',
      fr: 'Produit fantastique con\u00e7u pour les besoins de vrais patients.',
    },
    author: { en: 'Verified Customer', fr: 'Client v\u00e9rifi\u00e9' },
  },
  {
    id: 'caroline',
    rating: 5,
    text: {
      en: 'It\u2019s great to find such a well-designed and well-made product.',
      fr: 'C\u2019est formidable de trouver un produit aussi bien con\u00e7u et bien fabriqu\u00e9.',
    },
    author: { en: 'Caroline', fr: 'Caroline' },
  },
  {
    id: 'superhero-kit',
    rating: 5,
    text: {
      en: 'This product gave our family freedom again. It\u2019s now her sturdy superhero emergency kit.',
      fr: 'Ce produit a redonn\u00e9 la libert\u00e9 \u00e0 notre famille. C\u2019est maintenant son solide kit d\u2019urgence de superh\u00e9ros.',
    },
    author: { en: 'Parent of a child requiring daily injections', fr: 'Parent d\u2019un enfant n\u00e9cessitant des injections quotidiennes' },
  },
];
